import React, { useCallback, useState } from "react";
import { Grid, TextField } from "@mui/material";

const LocationForm = ({
  initialValues = {
    latitude: "",
    longitude: "",
    name: "",
    address: "",
  },
  onChange,
}) => {
  const [form, setForm] = useState({
    latitude: "",
    longitude: "",
    name: "",
    address: "",
    ...initialValues,
  });

  const handleFieldChange = useCallback(
    (field) => (event) => {
      const newValue = event.target.value;
      setForm((prev) => {
        const updatedForm = { ...prev, [field]: newValue };
        onChange?.(updatedForm);
        return updatedForm;
      });
    },
    [onChange]
  );

  return (
    <Grid container spacing={2}>
      {["latitude", "longitude", "name", "address"].map((field) => (
        <Grid item xs={12} sm={6} key={field}>
          <TextField
            label={field.charAt(0).toUpperCase() + field.slice(1)}
            fullWidth
            value={form[field]}
            onChange={handleFieldChange(field)}
            size="small"
            variant="outlined"
            InputLabelProps={{ shrink: true }}
            {...(field === "latitude" || field === "longitude"
              ? { type: "number", inputProps: { step: "any" } }
              : {})}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default LocationForm;
